export const enum Permission {
    ACCESS_ROUTING_SERVICE = "ACCESS_ROUTING_SERVICE",
    OPTIMIZE_SCHEDULE = "OPTIMIZE_SCHEDULE",
    ACCESS_TMS = "ACCESS_TMS",
    ACCESS_SLA_REPORT = "ACCESS_SLA_REPORT",
}

export const PermissionLabels: { [key in Permission]: string } = {
    [Permission.ACCESS_ROUTING_SERVICE]: "라우팅 서비스",
    [Permission.OPTIMIZE_SCHEDULE]: "스케줄 동선 최적화",
    [Permission.ACCESS_TMS]: "TMS 접근",
    [Permission.ACCESS_SLA_REPORT]: "SLA 리포트",
};

export const findPermissionLabel = (permission: Permission) => {
    return PermissionLabels[permission]
}

export const includesPermission = (permissions: Permission[], permission: Permission) => {
    return permissions.includes(permission)
}
